export const formatDecimalMinutes = (decimalMinutes: number) => {
  const minutes = Math.floor(decimalMinutes % 60);
  const seconds = Math.round((decimalMinutes % 1) * 60);
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${minutes}:${formattedSeconds}`;
};
